/* eslint-disable prettier/prettier */
// data.js
/* eslint-disable react/prop-types */


// API
import { getPersistedData } from "apis/api";


export default async function persistedPaymentsDataTable() {


    try {
        const response = await getPersistedData("payments");
        const persistedPaymentsData = JSON.parse(response.body);
        // console.log(persistedPaymentsData);

        const persistedPaymentsRows = persistedPaymentsData.map((bill) => ({
            CustomAdjustment: bill?.CustomAdjustment || "",
            attorney: bill?.attorney || "",
            id: bill?.id || "",
            invoice: bill?.invoice || "",
            InvoicedAmountAtty: bill?.InvoicedAmountAtty || "",
            GuaranteedPrevPaid: bill?.GuaranteedPrevPaid || "",
            CustomAdjustmentPrevPaid: bill?.CustomAdjustmentPrevPaid || "",
            GuaranteedPaymentDate: bill?.GuaranteedPaymentDate || "",
            OnCollectionPaymentDate: bill?.OnCollectionPaymentDate || "",
            // client_name: bill?.client?.name || "",
            // client_initials: bill?.client?.initials || "",
            // client_type: bill?.client?.type || "",
            // client_etag: bill?.client?.etag || "",
            // responsible_attorney_id: bill?.responsible_attorney?.id,
            // responsible_attorney_etag: bill?.responsible_attorney?.etag || "",
            // responsible_attorney_name: bill?.responsible_attorney?.name || "",
            // originating_attorney_id: bill?.originating_attorney?.id || 0,
            // originating_attorney_etag: bill?.originating_attorney?.etag || "",
            // originating_attorney_name: bill?.originating_attorney?.name || "",
        }));

        const persistedPaymentsColumns = [
            { Header: "CustomAdjustment", accessor: "CustomAdjustment", align: "center" },
            { Header: "attorney", accessor: "attorney", align: "center" },
            { Header: "id", accessor: "id", align: "center" },
            { Header: "invoice", accessor: "invoice", align: "center" },
            { Header: "InvoicedAmountAtty", accessor: "InvoicedAmountAtty", align: "center" },
            { Header: "GuaranteedPrevPaid", accessor: "GuaranteedPrevPaid", align: "center" },
            { Header: "CustomAdjustmentPrevPaid", accessor: "CustomAdjustmentPrevPaid", align: "center" },
            { Header: "GuaranteedPaymentDate", accessor: "GuaranteedPaymentDate", align: "center" },
            { Header: "OnCollectionPaymentDate", accessor: "OnCollectionPaymentDate", align: "center" },

        ];

        return { persistedPaymentsColumns, persistedPaymentsRows, persistedPaymentsData };
    } catch (error) {
        console.error("Error in persistedPaymentsTableData:", error);
        return { persistedPaymentsRows: [], persistedPaymentsColumns: [] };
    }
}
